import { render, staticRenderFns } from "./ChallengeSettingsPage.vue?vue&type=template&id=1341b47f&"
import script from "./ChallengeSettingsPage.vue?vue&type=script&lang=js&"
export * from "./ChallengeSettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports